"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var DefaultLegend_1 = require("../Common/DefaultLegend");
var DefaultYAxis_1 = require("../Common/DefaultYAxis");
var DefaultXAxis_1 = require("../Common/DefaultXAxis");
var DefaultCartesianGrid_1 = require("../Common/DefaultCartesianGrid");
var DefaultBarShapes_1 = require("../Common/DefaultBarShapes");
var inversify_react_1 = require("inversify-react");
var MAX_BAR_WIDTH = 42;
function MultiMetricStackedBarChart(_a) {
    var data = _a.data, _b = _a.colors, colors = _b === void 0 ? {} : _b, config = _a.config;
    var maxNumber = data.reduce(function (max, next) {
        var total = next.draft + next.live + next.accepted + next.declined;
        if (total > max)
            return total;
        return max;
    }, 0);
    var isMobile = (0, inversify_react_1.useInjection)("isMobile")();
    return (react_1.default.createElement("div", { className: "chart__container" },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
            react_1.default.createElement(recharts_1.BarChart, { data: data },
                (0, DefaultCartesianGrid_1.GetDefaultCartesianGrid)(),
                (0, DefaultLegend_1.GetDefaultLegend)(),
                (0, DefaultXAxis_1.GetDefaultXAxis)({ data: data, isMobile: isMobile }),
                (0, DefaultYAxis_1.GetDefaultYAxis)({
                    dataMax: maxNumber,
                    config: config === null || config === void 0 ? void 0 : config.yAxis,
                    isMobile: isMobile,
                }),
                Object.entries(data[0]).map(function (_a) {
                    var _b = __read(_a, 1), key = _b[0];
                    if (!["draft", "live", "accepted", "declined"].includes(key))
                        return null;
                    return (react_1.default.createElement(recharts_1.Bar, { key: key, dataKey: key, maxBarSize: MAX_BAR_WIDTH, stackId: "a", fill: colors[key], isAnimationActive: false, shape: function (props) { return react_1.default.createElement(DefaultBarShapes_1.DefaultBarShapeWithGap, { shapeProps: props }); } }));
                })))));
}
exports.default = MultiMetricStackedBarChart;
